module.exports = __webpack_public_path__ + "static/media/after_smurfs.d3dddd41.mp3";